import { useEffect } from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { SendMessage } from 'react-use-websocket';
import { PermissionDenied, PermissionEnum, IconLoader } from '@ui/src';
import { useAppSelector } from '@store';
import {
  useLazyGetTransactionsDictionariesQuery,
  useLazyGetTransactionsDictionariesWithoutGLQuery,
  useLazyGetTransactionsBaseCurrencyQuery,
  useLazyGetTransactionsCurrenciesQuery,
  useLazyGetTransactionsCountriesQuery,
} from '../../store/dictionaries/services';
import IncomingList from './list';

import cn from './styles.module.css';

const Incoming = (): React.JSX.Element => {
  const [getDictionaries] = useLazyGetTransactionsDictionariesQuery();
  const [getDictionariesWithoutGL] =
    useLazyGetTransactionsDictionariesWithoutGLQuery();
  const [getTransactionBaseCurrency] =
    useLazyGetTransactionsBaseCurrencyQuery();
  const [getTransactionCurrencies] = useLazyGetTransactionsCurrenciesQuery();
  const [getTransactionCountries] = useLazyGetTransactionsCountriesQuery();

  const {
    activePermissions,
    countries,
    currencies,
    baseCurrency,
    accounts,
    pspPartnerAccounts,
  } = useAppSelector((state) => state.transactionsDictionaries);
  const { values: transactionsTypes } = useAppSelector(
    (state) => state.settings.transactionsTypes,
  );

  const { sendMessage } = useOutletContext<{ sendMessage: SendMessage }>();

  useEffect(() => {
    if (
      activePermissions &&
      activePermissions.includes(PermissionEnum.TRANSACTIONS_INCOMING_LIST)
    ) {
      if (!pspPartnerAccounts) {
        getDictionariesWithoutGL();
      }

      if (!accounts) {
        getDictionaries();
      }

      if (!currencies) {
        getTransactionCurrencies();
      }

      if (!countries) {
        getTransactionCountries();
      }

      if (!baseCurrency) {
        getTransactionBaseCurrency();
      }
    }
  }, [
    activePermissions,
    baseCurrency,
    currencies,
    countries,
    pspPartnerAccounts,
    accounts,
  ]);

  useEffect(() => {
    let title = 'Incoming transactions';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content = (
    <div className={cn.incomingLoader}>
      <IconLoader />
    </div>
  );

  if (activePermissions && transactionsTypes) {
    if (
      activePermissions.includes(PermissionEnum.TRANSACTIONS_INCOMING_LIST) &&
      transactionsTypes?.find((item) => item.name === 'INCOMING')?.active
    ) {
      content = (
        <div className={cn.incoming}>
          <IncomingList />
          <Outlet context={{ sendMessage }} />
        </div>
      );
    } else {
      content = <PermissionDenied />;
    }
  }

  return content;
};

export default Incoming;
